<a
  *ngIf="tab"
  class="t-tab{{ tab.tabClass ? ' ' + tab.tabClass : '' }}"
  role="tab"
  [attr.aria-controls]="'tabContent-' + tab.tabId"
  [ngClass]="{ 'is-active': tab.isActive || isActive }"
  (click)="setActiveTabOnClick(tab)"
  [class.disabled]="tab.disabled"
  >{{ tab.tabTitle | translate }}</a
>
